import index from "./gallery.vue";
export default index;
